var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchEmptyState = function SvgSearchEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 145,
    viewBox: "0 0 131 145"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#98ACB5",
    strokeWidth: 3,
    transform: "translate(2 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 50c10.493 0 19-8.507 19-19"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 49,
    x: 65.5,
    y: 49.5,
    rx: 6.5,
    transform: "rotate(-45 72 74)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE1E7",
    d: "M57.318 44 43.16 58.16 29 44h-7C9.85 44 0 34.15 0 22S9.85 0 22 0h41c12.15 0 22 9.85 22 22s-9.85 22-22 22h-5.682z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.5,
    r: 4.5,
    fill: "#98ACB5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 22.5,
    r: 4.5,
    fill: "#98ACB5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 22.5,
    r: 4.5,
    fill: "#98ACB5"
  })))));
};
export { SvgSearchEmptyState as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMzEiIGhlaWdodD0iMTQ1IiB2aWV3Qm94PSIwIDAgMTMxIDE0NSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHN0cm9rZT0iIzk4QUNCNSIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDUwKSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjMyIiBjeT0iMzIiIHI9IjMyIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjMyIiBjeT0iMzIiIHI9IjI1Ii8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMSA1MGMxMC40OTMgMCAxOS04LjUwNyAxOS0xOSIvPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iMTMiIGhlaWdodD0iNDkiIHg9IjY1LjUiIHk9IjQ5LjUiIHJ4PSI2LjUiIHRyYW5zZm9ybT0icm90YXRlKC00NSA3MiA3NCkiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDYpIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0RCRTFFNyIgZD0iTTU3LjMxOCA0NEw0My4xNiA1OC4xNiAyOSA0NGgtN0M5Ljg1IDQ0IDAgMzQuMTUgMCAyMlM5Ljg1IDAgMjIgMGg0MWMxMi4xNSAwIDIyIDkuODUgMjIgMjJzLTkuODUgMjItMjIgMjJoLTUuNjgyeiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNC41IiBjeT0iMjIuNSIgcj0iNC41IiBmaWxsPSIjOThBQ0I1Ii8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjQyLjUiIGN5PSIyMi41IiByPSI0LjUiIGZpbGw9IiM5OEFDQjUiLz4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iNjAuNSIgY3k9IjIyLjUiIHI9IjQuNSIgZmlsbD0iIzk4QUNCNSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";